import { AuthService, PermissionService } from '@abp/ng.core';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ModalBuilder } from '@zendra/shared';
import { InventoryProjection } from './inventory-projection';
import {
  INVENTORY_PROJECTION_CONFIG,
  INVENTORY_PROJECTION_MODAL_CONFIG,
} from './inventory-projection.config';

export const inventoryProjectionModalGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  if (!authService.isAuthenticated) {
    authService.navigateToLogin();
  } else {
    const permissionService = inject(PermissionService);
    if (permissionService.getGrantedPolicy(INVENTORY_PROJECTION_CONFIG.permission)) {
      inject(ModalBuilder).openModal(InventoryProjection, INVENTORY_PROJECTION_MODAL_CONFIG);
    }
  }

  return false;
};
